import React, { useState } from 'react';
import { Star } from 'lucide-react';
import axios from 'axios';
import { toast } from '../hooks/use-toast';

// Use relative URLs for same-origin requests (no CORS)
const API_URL = '';

// eslint-disable-next-line no-unused-vars
const RatingWidget = ({ sessionId, reviewerId, currentRating = 0 }) => {
  const [rating, setRating] = useState(0);
  const [hoverRating, setHoverRating] = useState(0);
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmitRating = async (selectedRating) => {
    setSubmitting(true);
    
    try {
      const response = await axios.post(`${API_URL}/api/public/rating`, {
        session_id: sessionId,
        reviewer_id: reviewerId,
        rating: selectedRating
      });

      setRating(selectedRating);
      setSubmitted(true);
      
      toast({
        title: "✅ Rating submitted!",
        description: response.data.message
      });
    } catch (error) {
      console.error('Error submitting rating:', error);
      toast({
        title: "Error",
        description: error.response?.data?.detail || "Failed to submit rating",
        variant: "destructive"
      });
    } finally {
      setSubmitting(false);
    }
  };

  if (submitted) {
    return (
      <div className="text-center py-4">
        <div className="flex items-center justify-center gap-1 mb-2">
          {[1, 2, 3, 4, 5].map((star) => (
            <Star
              key={star}
              className={`w-6 h-6 ${
                star <= rating ? 'fill-[#F2D857] text-[#F2D857]' : 'text-gray-400'
              }`}
            />
          ))}
        </div>
        <p className="text-sm text-gray-400">Thank you for your rating!</p>
      </div>
    );
  }

  return (
    <div className="text-center py-4">
      <p className="text-sm text-gray-300 mb-3">Rate this session:</p>
      <div className="flex items-center justify-center gap-1">
        {[1, 2, 3, 4, 5].map((star) => (
          <button
            key={star}
            onClick={() => !submitting && handleSubmitRating(star)}
            onMouseEnter={() => setHoverRating(star)}
            onMouseLeave={() => setHoverRating(0)}
            disabled={submitting}
            className="transition-transform hover:scale-110 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <Star
              className={`w-8 h-8 ${
                star <= (hoverRating || rating)
                  ? 'fill-[#F2D857] text-[#F2D857]'
                  : 'text-gray-400 hover:text-[#F2D857]/50'
              }`}
            />
          </button>
        ))}
      </div>
      {submitting && (
        <p className="text-sm text-gray-400 mt-2">Submitting...</p>
      )}
    </div>
  );
};

export default RatingWidget;
